import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { Flex } from '@finect/tabular-core/Flex';
export var InlineFlex = styled(Flex).withConfig({
  displayName: "partials__InlineFlex",
  componentId: "sc-o2x6qm-0"
})(["display:inline-flex;"]);
export var ViewMore = styled.span.withConfig({
  displayName: "partials__ViewMore",
  componentId: "sc-o2x6qm-1"
})(["cursor:pointer;color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, getFont('-1'));
export var TooltipContent = styled.div.withConfig({
  displayName: "partials__TooltipContent",
  componentId: "sc-o2x6qm-2"
})(["padding:4px;", " ", "{margin-top:4px;}"], fontSmoothing, Flex);